/* Minimal Meta Pixel helper.
   Fully guarded so it can NEVER crash the app. */

var PIXEL_ID = '28914431981489824'
var installed = false

export function installMetaPixel() {
  try {
    if (typeof window === 'undefined') return
    if (installed) return
    installed = true

    var w = window as any

    if (!w.fbq) {
      var n: any = function () {
        if (n.callMethod) {
          n.callMethod.apply(n, arguments)
        } else {
          n.queue.push(arguments)
        }
      }
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      w.fbq = n
      if (!w._fbq) w._fbq = n

      var t = document.createElement('script')
      t.async = true
      t.src = 'https://connect.facebook.net/en_US/fbevents.js'
      var firstScript = document.getElementsByTagName('script')[0]
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(t, firstScript)
      } else if (document.head) {
        document.head.appendChild(t)
      }
    }

    w.fbq('init', PIXEL_ID)
    w.fbq('track', 'PageView')
    w.fbq('track', 'ViewContent')
  } catch (err) {
    // never throw
    // eslint-disable-next-line no-console
    console.warn('[MetaPixel] install failed:', err)
  }
}

export function trackPixelEvent(eventName: string) {
  try {
    if (typeof window === 'undefined') return
    var w = window as any
    if (typeof w.fbq !== 'function') return
    w.fbq('track', eventName)
  } catch {
    // ignore
  }
}
